<div class="employee-details-feedbacks">
	<div class="employee-details-feedbacks__header">
		<h3 class="employee-details-feedbacks__title">Feedbacks</h3>
		<p class="employee-details-feedbacks__subtitle">
			Histórico completo de feedbacks contínuos organizados por tipo, do mais recente ao mais antigo.
		</p>
	</div>

	<ng-container *ngIf="isLoading; else contentBlock">
		<div class="employee-details-feedbacks__loading">
			<span class="spinner-border text-primary spinner-border-sm"></span>
			<span>Carregando</span>
		</div>
	</ng-container>

	<ng-template #contentBlock>
		<ng-container *ngIf="!hasLoadError; else loadErrorBlock">
			<div class="feedback-columns">
				<div class="feedback-column" *ngFor="let column of columns">
					<div class="feedback-column__header">
						<span class="feedback-column__title">{{ column.title }}</span>
						<span class="feedback-column__badge feedback-column__badge--{{ column.cssClass }}">
							{{ getCountByType(column.type) }}
						</span>
					</div>

					<div class="feedback-column__list" *ngIf="getCountByType(column.type) > 0">
						<article
							class="feedback-card feedback-card--{{ column.cssClass }}"
							*ngFor="let item of getItemsByType(column.type)"
						>
							<div class="feedback-card__meta">
								<div class="feedback-card__author">
									<span class="feedback-card__avatar" aria-hidden="true">{{ item.evaluatorInitials }}</span>
									<div class="feedback-card__author-text">
										<span class="feedback-card__name">{{ item.evaluatorName }}</span>
										<span class="feedback-card__job" *ngIf="item.evaluatorJobTitle">
											{{ item.evaluatorJobTitle }}
										</span>
									</div>
								</div>
								<span class="feedback-card__date">{{ item.creationDate | date: 'dd/MM/yyyy' }}</span>
							</div>
							<p class="feedback-card__description">{{ item.description }}</p>
						</article>
					</div>

					<div class="feedback-column__empty" *ngIf="getCountByType(column.type) === 0">
						Nenhum feedback
					</div>
				</div>
			</div>

			<section class="feedback-section-datatable" *ngIf="allItems.length > 0; else emptyTable">
				<div class="card card-fit card-table shadow mt-2">
					<div class="card-body card-table p-0">
						<div class="table-responsive">
							<ngx-datatable
								class="table ngx-datatable-custom"
								[rows]="pagedItems"
								[count]="count"
								[limit]="queryParams.top"
								[offset]="(queryParams.page || 1) - 1"
								[rowHeight]="'auto'"
								[columnMode]="'force'"
								[headerHeight]="46"
								[footerHeight]="56"
								[externalPaging]="true"
								[externalSorting]="true"
								[sorts]="currentSort ? [currentSort] : []"
								(page)="onPage($event)"
								(sort)="onSort($event)"
							>
								<ngx-datatable-column name="DATA" prop="creationDate" [width]="140" [canAutoResize]="false">
									<ng-template ngx-datatable-header-template>
										<div class="feedback-column-filter-header">
											<div class="feedback-column-filter-title-row">
												<span>DATA</span>
												<button
													type="button"
													class="btn btn-link feedback-column-filter-toggle"
													[class.active]="columnFilterVisibility.creationDate || !!selectedDate"
													(click)="toggleColumnFilter('creationDate'); $event.stopPropagation()"
												>
													<i class="feather icon-search"></i>
												</button>
											</div>
											<div class="feedback-column-filter-input" *ngIf="columnFilterVisibility.creationDate">
												<div class="feedback-column-date-range-wrapper" (click)="$event.stopPropagation()">
													<app-date-range-picker
														class="feedback-column-date-range-picker"
														[value]="selectedDate"
														label=""
														[disablePastDates]="false"
														[maxSelectableDate]="todayDate"
														(dateSelect)="onDateRangeChange($event)"
													>
													</app-date-range-picker>
												</div>
												<button
													*ngIf="selectedDate"
													type="button"
													class="btn btn-link feedback-column-filter-clear"
													(click)="clearColumnFilter('creationDate'); $event.stopPropagation()"
												>
													<i class="feather icon-x"></i>
												</button>
											</div>
										</div>
									</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										{{ row.creationDate | date: 'dd/MM/yyyy' }}
									</ng-template>
								</ngx-datatable-column>

								<ngx-datatable-column name="TIPO" prop="type" [width]="150" [canAutoResize]="false">
									<ng-template ngx-datatable-header-template>TIPO</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										<span class="badge feedback-type-badge" [ngClass]="'feedback-type-badge--' + row.type">
											{{ row.typeLabel }}
										</span>
									</ng-template>
								</ngx-datatable-column>

								<ngx-datatable-column name="GESTOR" prop="evaluatorName" [width]="280" [canAutoResize]="false">
									<ng-template ngx-datatable-header-template>
										<div class="feedback-column-filter-header">
											<div class="feedback-column-filter-title-row">
												<span>GESTOR</span>
												<button
													type="button"
													class="btn btn-link feedback-column-filter-toggle"
													[class.active]="columnFilterVisibility.evaluatorName || !!evaluatorColumnQuery"
													(click)="toggleColumnFilter('evaluatorName'); $event.stopPropagation()"
												>
													<i class="feather icon-search"></i>
												</button>
											</div>
											<div class="feedback-column-filter-input" *ngIf="columnFilterVisibility.evaluatorName">
												<input
													type="text"
													class="form-control form-control-sm"
													placeholder="Buscar"
													[(ngModel)]="evaluatorColumnQuery"
													(input)="onEvaluatorFilterChange()"
													(click)="$event.stopPropagation()"
												/>
												<button
													*ngIf="evaluatorColumnQuery"
													type="button"
													class="btn btn-link feedback-column-filter-clear"
													(click)="clearColumnFilter('evaluatorName'); $event.stopPropagation()"
												>
													<i class="feather icon-x"></i>
												</button>
											</div>
										</div>
									</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										<span class="font-weight-bolder text-uppercase">{{ row.evaluatorName }}</span>
									</ng-template>
								</ngx-datatable-column>

								<ngx-datatable-column
									name="DESCRIÇÃO"
									prop="description"
									[sortable]="false"
									[flexGrow]="1"
									[minWidth]="220"
								>
									<ng-template ngx-datatable-header-template>DESCRIÇÃO</ng-template>
									<ng-template ngx-datatable-cell-template let-row="row">
										<span class="feedback-description-cell">{{ row.description }}</span>
									</ng-template>
								</ngx-datatable-column>
							</ngx-datatable>
						</div>

						<div class="card-footer">
							<app-paginator
								type="squared"
								class="flex-1"
								[count]="count"
								[filter]="queryParams.filter"
								[queryParams]="queryParams"
								[optionSize]="[8, 10, 30, 50]"
								[showDisplayedCount]="true"
								(query)="onPaginatorQuery()"
							>
							</app-paginator>
						</div>
					</div>
				</div>
			</section>

			<ng-template #emptyTable>
				<div class="employee-details-feedbacks__empty" *ngIf="!isLoading && allItems.length === 0">
					Não há registros para exibir.
				</div>
			</ng-template>
		</ng-container>

		<ng-template #loadErrorBlock>
			<div class="employee-details-feedbacks__empty">
				Não foi possível carregar os feedbacks.
			</div>
		</ng-template>
	</ng-template>
</div>
